import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import Disclaimer from '../Disclaimer';
import PdfForm from '../PdfForm';
import ShareFrom from '../ShareForm';
import TransomConfigurator from './../TransomConfigurator';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view01ImageOptions } from './views/exterior_view01'

class XP44Summary extends Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: false
        };
    }

    render() {
        let imageOptions = exterior_view01ImageOptions;

        let image = (
            <TransomConfigurator colorMultiplier={0.75} name={this.props.configuration.transom.Name} port={this.props.configuration.transom.Port} transomSize={{ width: 2895, height: 780 }} transform={
                [
                    0.071489, -0.001427, 0, -0.000032,
                    0.012064, 0.088505, 0, 0.000043,
                    0, 0, 1, 0,
                    207, 355, 0, 1
                ]}>
                <ConfiguratorImage boat="XP44" configuration={this.props.configuration.exterior} options={imageOptions} />
            </TransomConfigurator>
        );

        if (this.props.configuration.exterior.BathingPlatform.value === 1) {
            image = <ConfiguratorImage boat="XP44" configuration={this.props.configuration.exterior} options={imageOptions} />;
        }



        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{position:'relative'}}>
                    <h1><Trans defaults='Summary' /></h1>
                    <h2><Trans defaults='Congratulations!' /></h2>
                    <p><Trans defaults='You have now configured the basics of an Xp 44. If you want a full configuration of your boat, please contact your local X-Yachts Dealer.' /></p>
                 

                    <PdfForm boat="xp44" country={this.props.country} countries={this.props.countries} configuration={this.props.configuration} code={this.props.code} />


                    <ShareFrom configuration={this.props.configuration} boat="xp44" code={this.props.code} />
                    
                    <Disclaimer />
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(XP44Summary);


// WEBPACK FOOTER //
// ./src/XP44/XP44Summary.js